import { render } from "./AdvertisementForm.vue?vue&type=template&id=a338e898&scoped=true"
import script from "./AdvertisementForm.vue?vue&type=script&lang=js"
export * from "./AdvertisementForm.vue?vue&type=script&lang=js"

import "./AdvertisementForm.vue?vue&type=style&index=0&id=a338e898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a338e898"]])

export default __exports__